import { render, staticRenderFns } from "./SkillCheck.vue?vue&type=template&id=38df8524&"
import script from "./SkillCheck.vue?vue&type=script&lang=js&"
export * from "./SkillCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports